import axios from './utils/axios';
import { utils } from 'gipsy-misc';

export var get = function get(params) {
  var endpoint = '/tags';
  if (params) {
    endpoint = utils.request.appendToUrl(endpoint, params);
  }
  return axios.get(endpoint);
};

export var create = function create(body) {
  var endpoint = '/tags';
  return axios.post(endpoint, body);
};

export var edit = function edit(body) {
  var endpoint = '/tags/' + body.id;
  return axios.post(endpoint, body);
};

export var del = function del(id) {
  var endpoint = '/tags/' + id;
  return axios.delete(endpoint);
};
//# sourceMappingURL=tags.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/tags.js
// module id = 1086
// module chunks = 0